// extracted by mini-css-extract-plugin
module.exports = {"container":"RCMovies_container__1v7IX"};